import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RequestsFeatureKey } from './requests-feature-key';
import { RequestsState } from './requests.state';

export const RequestsFeatureSelector =
  createFeatureSelector<RequestsState>(RequestsFeatureKey);
// All Requests
export const allRequestsSelector = createSelector(
  RequestsFeatureSelector,
  (state) => {
    return state.allRequests;
  }
);
// My Requests Count
export const myRequestsCountSelector = createSelector(
  RequestsFeatureSelector,
  (state) => {
    return state.myRequestsCount;
  }
);
// Create Request
export const createRequestSelector = createSelector(
  RequestsFeatureSelector,
  (state) => {
    return state.createRequest;
  }
);
// My Requests
export const myRequestsSelector = createSelector(
  RequestsFeatureSelector,
  (state) => {
    return state.myRequests;
  }
);
// Edit Request
export const editRequestSelector = createSelector(
  RequestsFeatureSelector,
  (state) => {
    return state.editRequest;
  }
);
// Export Requests
export const exportRequestsSelector = createSelector(
  RequestsFeatureSelector,
  (state) => {
    return state.exportRequests;
  }
);

// Request By Id
export const requestByIdSelector = createSelector(
  RequestsFeatureSelector,
  (state) => {
    return state.requestById;
  }
);

/**
 * All Requests Selector
 */
export const allRequestsSuccessSelector = createSelector(
  allRequestsSelector,
  (state) => {
    return state.data;
  }
);
export const allRequestsFailureSelector = createSelector(
  allRequestsSelector,
  (state) => {
    return state.failure;
  }
);
export const allRequestsLoadingSelector = createSelector(
  allRequestsSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * Create Request Selector
 */
export const createRequestSuccessSelector = createSelector(
  createRequestSelector,
  (state) => {
    return state.data;
  }
);
export const createRequestFailureSelector = createSelector(
  createRequestSelector,
  (state) => {
    return state.failure;
  }
);
export const createRequestLoadingSelector = createSelector(
  createRequestSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * Edit Request Selector
 */
export const editRequestSuccessSelector = createSelector(
  editRequestSelector,
  (state) => {
    return state.data;
  }
);
export const editRequestFailureSelector = createSelector(
  editRequestSelector,
  (state) => {
    return state.failure;
  }
);
export const editRequestLoadingSelector = createSelector(
  editRequestSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * Export Requests Selector
 */
export const exportRequestsSuccessSelector = createSelector(
  exportRequestsSelector,
  (state) => {
    return state.data;
  }
);
export const exportRequestsFailureSelector = createSelector(
  exportRequestsSelector,
  (state) => {
    return state.failure;
  }
);
export const exportRequestsLoadingSelector = createSelector(
  exportRequestsSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * My Requests Selector
 */
export const myRequestsSuccessSelector = createSelector(
  myRequestsSelector,
  (state) => {
    return state.data;
  }
);
export const myRequestsFailureSelector = createSelector(
  myRequestsSelector,
  (state) => {
    return state.failure;
  }
);
export const myRequestsLoadingSelector = createSelector(
  myRequestsSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Request By Id Selector
 */
export const requestByIdSuccessSelector = createSelector(
  requestByIdSelector,
  (state) => {
    return state.data;
  }
);
export const requestByIdFailureSelector = createSelector(
  requestByIdSelector,
  (state) => {
    return state.failure;
  }
);
export const requestByIdLoadingSelector = createSelector(
  requestByIdSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * My Request Count
 */
export const myRequestsCountSuccessSelector = createSelector(
  myRequestsCountSelector,
  (state) => {
    return state.data;
  }
);
export const myRequestsCountFailureSelector = createSelector(
  myRequestsCountSelector,
  (state) => {
    return state.failure;
  }
);
export const myRequestsCountLoadingSelector = createSelector(
  myRequestsCountSelector,
  (state) => {
    return state.loading;
  }
);
